import { Form, FormProps } from "@/components/form";
import { z } from "zod/v4";

export const additionalArticuloDataSchema = z.object({
    numeroItem: z.string(),
    cantidadPorCaja: z.number().or(z.literal("")),
    cantidadMinima: z.number().or(z.literal(""))
})

export default function ArticuloGeneralInfoAdditionalDataForm({
    form,
    ...props
}: FormProps<z.infer<typeof additionalArticuloDataSchema>>) {
    return <Form form={form} gap={3} {...props}>
        <Form.TextField name="numeroItem" label="Número de  Ítem" />
        <Form.NumberField name="cantidadPorCaja" label="Cant. por Caja" decimalScale={0} />
        <Form.NumberField name="cantidadMinima" label="Cant. Mínima" decimalScale={0} />
        <Form.SubmitButton>Confirmar</Form.SubmitButton>
    </Form>
}